import { saveAs } from 'file-saver';
import store from '../store';
import conf from "../config";
import userApi from "../api/user"
import flashcache from "./flashcache/index"
import router from "../routes";
var dayjs = require('dayjs');

export default {

    //数据校验
    check: function(type, v, mis = '') {

        var result = false;

        switch (type) {

            //校验空数据
            case 'NULL':
                if (typeof v != 'string') {
                    if (v === '' || v === undefined || v === null) {
                        result = true;
                        if (mis !== '') { mis.t.$message({ message: mis.m, type: mis.type }); }
                    }
                } else {
                    if (v === '' || v === undefined || v === null || v.match(/^[ ]*$/)) {
                        result = true;
                        if (mis !== '') { mis.t.$message({ message: mis.m, type: mis.type }); }
                    }
                }


                break;

                //校验手机号
            case 'PHONE':

                var z = /^(((13[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(15[0-9]{1})|(19[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                // var z = /^(\\+?0?86\\-?)?1[3456789]\\d{9}$/;
                if (z.test(v)) {
                    result = true;
                }

                break;

                //密码格式
            case 'PWD':

                var z = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,30}$/;
                if (z.test(v)) {
                    result = true;
                }

                break;

                //工号格式
            case 'CODE':

                var z = /^[0-9a-zA-Z]{1,10}$/;
                if (z.test(v)) {
                    result = true;
                }

                break;

                ///邮箱格式
            case 'EMAIL':

                var z = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
                if (z.test(v)) {
                    result = true;
                }

                break;

        };



        return result;

    },

    //整理出字符串，号分割的参数
    string_para: function(arr, key) {

        var s = ''

        if (this.check('NULL', key)) {
            for (var i in arr) {
                s = s + arr[i] + ',';
            };
        } else {
            for (var i in arr) {
                s = s + arr[i][key] + ',';
            };
        }

        return s.substring(0, s.length - 1);

    },
    recordLog(data){
        userApi.recordClientLog({
            ...data
        })
    },
    // 线性数据整理
    linearData(data){

        if(!data || data.length==0 ||JSON.stringify(data) == '{}')return false;

        var rdata = {};
        if(data.length>0){
            for(var key in data[0]){
                rdata[key] = [];
            }
        }else{
            rdata = []
        }
        data.forEach(element => {
            for(var key in rdata){
                rdata[key].push(element[key])
            }
        });
        return rdata
    },
    //整理出字符串，号分割的参数
    string_para: function(arr, key) {

        var s = ''

        if (this.check('NULL', key)) {
            for (var i in arr) {
                s = s + arr[i] + ',';
            };
        } else {
            for (var i in arr) {
                s = s + arr[i][key] + ',';
            };
        }

        return s.substring(0, s.length - 1);

    },


    //任务队列
    nextRegister: function() {

        var args = arguments;
        var count = 0;
        var comm = {};

        function nextTime() {
            count++;
            if (count < args.length) {
                if (args[count] && Object.prototype.toString.call(args[count]) == '[object Function]') {
                    args[count](comm, nextTime);
                }
            }
        }

        if (args[count] && Object.prototype.toString.call(args[count]) == '[object Function]') {
            args[count](comm, nextTime);
        }

    },

    isEmojiCharacter: function(substring) {

        for (var i = 0; i < substring.length; i++) {
            var hs = substring.charCodeAt(i);
            if (0xd800 <= hs && hs <= 0xdbff) {
                if (substring.length > 1) {
                    var ls = substring.charCodeAt(i + 1);
                    var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
                    if (0x1d000 <= uc && uc <= 0x1f77f) {
                        return true;
                    }
                }
            } else if (substring.length > 1) {
                var ls = substring.charCodeAt(i + 1);
                if (ls == 0x20e3) {
                    return true;
                }
            } else {
                if (0x2100 <= hs && hs <= 0x27ff) {
                    return true;
                } else if (0x2B05 <= hs && hs <= 0x2b07) {
                    return true;
                } else if (0x2934 <= hs && hs <= 0x2935) {
                    return true;
                } else if (0x3297 <= hs && hs <= 0x3299) {
                    return true;
                } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 ||
                    hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b ||
                    hs == 0x2b50) {
                    return true;
                }
            }
        }
    },

    //问题详情跳转方法
    detailsgo: function(e) {

    },
    
    get_main_url:function(){
        return window.location.protocol+"//"+window.location.host;
    },

    GetUrlParam:function(paraName) {
    　　　　var url = document.location.toString();
    　　　　var arrObj = url.split("?");

    　　　　if (arrObj.length > 1) {
    　　　　　　var arrPara = arrObj[1].split("&");
    　　　　　　var arr;

    　　　　　　for (var i = 0; i < arrPara.length; i++) {
    　　　　　　　　arr = arrPara[i].split("=");

    　　　　　　　　if (arr != null && arr[0] == paraName) {
    　　　　　　　　　　return arr[1];
    　　　　　　　　}
    　　　　　　}
    　　　　　　return "";
    　　　　}
    　　　　else {
    　　　　　　return "";
    　　　　}
    },

    //取得当前浏览器高度
    get_win_view:function(){
        return window.innerHeight;
    },

    //时间去秒
    time_out_second:function(e){

        //数据是否合法
        var l = '2019-06-29 16:17:00'.length;

        if(e!=undefined&&e!=null&&e!=''){
            if(e.length!=l){
                console.warn('去秒函数入参格式不正确');
            }else{
                //去秒
                e = e.substring(0,16);
            }
        }

        return e;
    },
    

    //判断是否为null或undefined
    isNuu:function(e){
        let bo = true;
        if(e===undefined){
            bo = false;
        }
        return bo;
    },

    //获取当前浏览器类型及版本
    get_browser_type:function()
    {
        var UserAgent = navigator.userAgent.toLowerCase();
        var browser = null;
        var browserArray = {
            IE: window.ActiveXObject || "ActiveXObject" in window, // IE
            Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
            Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
            Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
            Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
            Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
            QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
            WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
        };
        for (var i in browserArray) {
            if (browserArray[i]) {
                browser = i;
            }
        }
        return browser;
        
    },

    //获取接口域名
    get_api_base:function(){
        return this.conf.api_url();
    },

    // 获取浏览器信息
    IEVersion:function() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if(fIEVersion == 7) {
                return 7;
            } else if(fIEVersion == 8) {
                return 8;
            } else if(fIEVersion == 9) {
                return 9;
            } else if(fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }   
        } else if(isEdge) {
            return 'edge';//edge
        } else if(isIE11) {
            return 11; //IE11  
        }else{
            return -1;//不是ie浏览器
        }
    },

    //附件名处理
    file_name_lastof: function(e, len = 0 , last = 0) {

        if(e==null||e==undefined||e=='')return;

        //整理文件名
        let filename = e;
        let lastindex = filename.lastIndexOf('/');
        let tmp =  filename.substr(lastindex+1+len,filename.length);

        if(last == 0){
            return tmp;
        }else{
            var fix = tmp.split('.')
            fix = fix[fix.length-1]
            return tmp.substring(0,tmp.length-last) +'.'+ fix
        }
        
    },

    //下载文件
    down_file(src, name=false) {

        var baseSrc = src;

        //是否有文件名
        if(!name){
            name = baseSrc;
        }
        
        //取得接口地址
        var apiURL = conf.api_url();
        
        //是否有带上接口地址
        if(baseSrc.indexOf(apiURL) == -1){
            baseSrc = apiURL + baseSrc;
        }

        //是否有拼接token
        if(baseSrc.indexOf('?token=') == -1){
            baseSrc = baseSrc + "?token=" + store.getters.token;
        }

        //文件名是否纯净
        if(name.indexOf('/') != -1){
            name = this.file_name_lastof(name);
        }

        console.log({
            url:baseSrc,
            name:name,
        })

        //第三方下载方法
        saveAs(baseSrc,name);

    },

    //下载文件
    down_file_8d(src, name=false) {

        var baseSrc = src;

        //是否有文件名
        if(!name){
            name = baseSrc;
        }
        
        // //取得接口地址
        var apiURL = conf.file_url;
        console.log(apiURL)
        
        //是否有带上接口地址
        if(baseSrc.indexOf(apiURL) == -1){
            baseSrc = apiURL + baseSrc;
        }

        //是否有拼接token
        // if(baseSrc.indexOf('?token=') == -1){
        //     baseSrc = baseSrc + "?token=" + store.getters.token;
        // }

        //文件名是否纯净
        if(name.indexOf('/') != -1){
            name = this.file_name_lastof(name);
        }

        console.log({
            url:baseSrc,
            name:name,
        })

        //第三方下载方法
        saveAs(baseSrc,name);
        // saveFileToLink(baseSrc,name,'pdf');

    },
    //下载文件拼接oasite
    down_file_8ds(src, name=false) {

        var baseSrc = src;

        //是否有文件名
        if(!name){
            name = baseSrc;
        }
        
        // //取得接口地址
        var apiURL = conf.file_url;
        
        //是否有带上接口地址
        if(baseSrc.indexOf(apiURL) == -1){
            baseSrc = apiURL + 'oasite' + baseSrc;
        }

        //是否有拼接token
        // if(baseSrc.indexOf('?token=') == -1){
        //     baseSrc = baseSrc + "?token=" + store.getters.token;
        // }

        //文件名是否纯净
        if(name.indexOf('/') != -1){
            name = this.file_name_lastof(name);
        }

        console.log({
            url:baseSrc,
            name:name,
        })

        //第三方下载方法
        saveAs(baseSrc,name);
        // saveFileToLink(baseSrc,name,'pdf');

    },
    //取得企业状态
    compStart:function(e){

        var companyState = '';

        switch (e) { //公司状态
            case 0:
                companyState = '存续'
                break;
            case 1:
                companyState = '在业'
                break;
            case 2:
                companyState = '吊销'
                break;
            case 3:
                companyState = '注销'
                break;
            case 4:
                companyState = '迁入'
                break;
            case 5:
                companyState = '迁出'
                break;
            case 6:
                companyState = '停业'
                break;
            case 7:
                companyState = '清算'
                break;
        }

        return companyState;
    },

    //统计跳转
    censusJump: function(type,ids=false){
        if(!ids || ids.length==0) return;
        if(type == 'find'){
            flashcache.put('find_task_summary',ids)
            router.push({path:'/index/find_task'});
        }
        if(type == 'solve'){
            flashcache.put('solve_task_summary',ids)
            router.push({path:'/index/solve_task'});
        }
    },

    //节流
    throttle:function(func, wait) {
        let lastTime = null
        let timeout
        return function () {
            let context = this
            let now = new Date()
            // 判定不是一次抖动
            if (now - lastTime - wait > 0) {
            setTimeout(() => {
                func.apply(context, arguments)
            }, wait)
            } else {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            timeout = setTimeout(() => {
                func.apply(context, arguments)
            }, wait)
            }
            // 注意这里lastTime是上次的触发时间
            lastTime = now
        }
    },
    presetTime: {
        shortcuts: [
            {
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                }
            }, 
            {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                }
            }, 
            {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                }
            },
            {
                text: '最近一年',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                    picker.$emit('pick', [start, end]);
                }
            }
        ]
    },
    dayjs:dayjs

}


// WEBPACK FOOTER //
// ./src/communal/index.js